// Import Slick
import 'slick-carousel/slick/slick.min.js';

$(document).ready(function() {

    $('.js-cu').click(function () {
        $('#cu_modal').modal('show');
    });

    $('.js-find-car').click(function (e) {
        e.preventDefault();
        $('#car_modal').modal('show');
    });

    $('.js-menu-button').click(function (e) {
        e.preventDefault();
        $('.js-menu').toggleClass('is-open');
        $('body').toggleClass('modal-open');
    });

    $('.js-slick-car').each(function() {
        var currentSlick =  $(this);
        currentSlick.slick({
            autoplay: true,
            infinite: true,
            slidesToShow: 1,
            arrows: true,
            prevArrow: currentSlick.parent().find('.slick-prev'),
            nextArrow: currentSlick.parent().find('.slick-next'),
            dots: true,
        });
    });

    $('.js-slick-wdc').each(function() {
        var currentSlick =  $(this);
        currentSlick.slick({
            autoplay: true,
            infinite: true,
            slidesToShow: 1,
            arrows: true,
            prevArrow: currentSlick.parent().find('.slick-prev'),
            nextArrow: currentSlick.parent().find('.slick-next'),
            dots: true,
        });
    });

    $(window).on('scroll', function () {
        var viewportTop = $(window).scrollTop();
        if (viewportTop > lastViewportTop) {
            animateGrid();
        }
        lastViewportTop = viewportTop;
    });
    
    var lastViewportTop = 0;
    function animateGrid() {
        var delay = 2;

        $($('.animate-card-x').get().reverse()).each(function(i, value){
            var elementTop = $(value).offset().top;
            var viewportTop = $(window).scrollTop();
            var viewportBottom = viewportTop + $(window).height();
    
            if ((elementTop) <= viewportBottom && !$(value).hasClass('is-on-view')) {
                $(value).addClass('is-on-view');
                $(value).css('transition-delay', delay * 200 + 'ms');
                delay++;
            }
        });
    
        $.each($('.animate-card'), function (i, value) {
            var elementTop = $(value).offset().top - 300;
            var viewportTop = $(window).scrollTop();
            var viewportBottom = viewportTop + $(window).height();
    
            if ((elementTop) <= viewportBottom && !$(value).hasClass('is-on-view')) {
                $(value).addClass('is-on-view');
                $(value).css('transition-delay', delay * 100 + 'ms');
                delay++;
            }
        });
    }
    animateGrid();
});



// WEBPACK FOOTER //
// ./scripts/general.js